const HEADER_JSON_TYPE = 'application/json; charset=utf-8'
let baseURL = process.env.VUE_APP_API_BASE_URL

const currentPath = window.location.href
// 處理 API 呼叫路徑問題, 修改為非相對路徑
if (baseURL.indexOf('http') === -1 && currentPath) {
  let endStr
  if (process.env.VUE_APP_BASE_ROUTE) {
    // 根據配置的 VUE_APP_BASE_ROUTE 來判讀
    if (process.env.VUE_APP_BASE_ROUTE.endsWith('/')) {
      let len = process.env.VUE_APP_BASE_ROUTE.length
      endStr = process.env.VUE_APP_BASE_ROUTE.substring(0, len - 1)
    } else {
      endStr = process.env.VUE_APP_BASE_ROUTE
    }
    endStr = endStr.toLocaleLowerCase()
  } else {
    endStr = '/'
  }
  let currentPathLowerCase = currentPath.toLocaleLowerCase()
  let fromIndex = 10 // http://x.x  至少 10 個字元，避免 http://mia. 開頭問題
  let indexPoi = currentPathLowerCase.indexOf(endStr, fromIndex)
  if (indexPoi > -1) {
    let indexPoiEndSlash = currentPathLowerCase.indexOf('/', indexPoi + endStr.length)
    // 絕對路徑，以防止呼叫時因為當下 URL 問題而導致呼叫路徑錯誤
    let webRoot = ''
    if (indexPoiEndSlash > -1) {
      webRoot = currentPath.substring(0, indexPoiEndSlash)
    } else {
      if (currentPathLowerCase.endsWith(endStr)) {
        webRoot = currentPath.substring(0, indexPoi + endStr.length + 1)
      }
    }
    if (webRoot) {
      if (!webRoot.endsWith('/')) {
        webRoot += '/'
      }
      baseURL = webRoot + process.env.VUE_APP_API_BASE_URL
    }
  }
  if (baseURL && baseURL.indexOf('http') === -1 && !baseURL.startsWith('/')) {
    let webRoot = process.env.VUE_APP_BASE_ROUTE || '/'
    if (!webRoot.endsWith('/')) {
      webRoot += '/'
    }
    baseURL = webRoot + process.env.VUE_APP_API_BASE_URL
  }
}
if (process.env.NODE_ENV === 'development') {
  console.log(`[API_BASE_URL] : ${baseURL}`)
}
export const apiConfig = {
  baseURL,
  withCredentials: true,
  timeout: 600000,
  headers: {
    patch: { 'Content-Type': HEADER_JSON_TYPE },
    post: { 'Content-Type': HEADER_JSON_TYPE },
    put: { 'Content-Type': HEADER_JSON_TYPE }
  }
}

const biBaseConfig = {
  apiConfig
}

export default biBaseConfig
